export default __webpack_public_path__ + "images/41e9ead9c1d8ee2beee9f298117131c6-government.webp";